export default {
  umkmPage: (state, getters) => {
    return state.umkmPage;
  },
  total: (state, getters) => {
    return state.total;
  },
};
